import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ToastSlice {
  message: string;
  type: 'SUCCESS' | 'ERROR' | 'WARN' | 'INFO' | 'DEFAULT';
}

export type MenuType = 'Home' | 'Sumate' | 'Filo';

interface SharedInfo {
  loading: boolean;
  finallyProps: boolean;
  openToast: boolean;
  toast: ToastSlice;
  key: MenuType;
}

const initialState: SharedInfo = {
  loading: false,
  openToast: false,
  finallyProps: false, // Para saber si termino de buscar propiedades, falle o no
  key: 'Home',
  toast: {
    message: '',
    type: 'DEFAULT'
  }
};

export const sharedSlice = createSlice({
  name: 'shared',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setToast: (state, action: PayloadAction<ToastSlice>) => {
      state.toast = action.payload;
      state.openToast = true;
    },
    closeToast: state => {
      state.openToast = false;
    },
    setKey: (state, action: PayloadAction<MenuType>) => {
      state.key = action.payload;
    },
    setFinallyProps: (state, action: PayloadAction<boolean>) => {
      state.finallyProps = action.payload;
    }
  }
});

// Exporta las acciones para usarlas en los componentes
export const { setLoading, setToast, closeToast, setKey, setFinallyProps } = sharedSlice.actions;

// Exporta el reducer para usarlo en el store
export default sharedSlice.reducer;
